import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LoaderComponent } from '@shared/loader/loader.component';
import { RecentChatCardComponent } from '@shared/recent-chat-card/recent-chat-card.component';
import { HomeRecentChatViewModel } from '../home.models';

@Component({
  selector: 'app-home-recent-chats-section',
  standalone: true,
  imports: [CommonModule, LoaderComponent, RecentChatCardComponent],
  templateUrl: './home-recent-chats-section.component.html',
})
export class HomeRecentChatsSectionComponent {
  @Input() isLoading = false;
  @Input() chats: HomeRecentChatViewModel[] = [];
  @Input() totalCount = 0;

  @Output() chatSelected = new EventEmitter<any>();
  @Output() viewAllRequested = new EventEmitter<void>();

  readonly openChat = (chat: HomeRecentChatViewModel) => this.chatSelected.emit(chat.raw);

  onSelect(chat: HomeRecentChatViewModel): void {
    this.chatSelected.emit(chat.raw);
  }
}
